import { isInstitutionGrouped } from "../../../utils/constants";
import { Tag } from "antd";
import { typesPrestation } from "../../../utils/typesPrestation";
import { renderAdress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { useTranslation } from "react-i18next";

// Convert columnsInstitutionsList to a function but keep the original name
export const columnsInstitutionsList = () => {
  const { t } = useTranslation(); // Initialize useTranslation

  return [
    {
      title: t("InstitutionsListForms.columnsInstitutionsList.name"),
      dataIndex: "name",
      key: "name",
      render: (n, record) => n,
      width: "15%",
      sorter: (a, b) => {
        return a.name.localeCompare(b.name);
      },
    },
    {
      title: t("InstitutionsListForms.columnsInstitutionsList.mainType"),
      dataIndex: "mainType",
      width: "15%",
      key: "mainType",
      sorter: (a, b) => {
        return a?.mainType?.localeCompare(b?.mainType);
      },
    },
    {
      title: t("InstitutionsListForms.columnsInstitutionsList.defaultAddress"),
      dataIndex: "defaultAddress",
      width: "15%",
      key: "defaultAddress",
      render: (a, i) => renderAdress(a, false, i),
    },
    {
      title: t("InstitutionsListForms.columnsInstitutionsList.tags"),
      dataIndex: "tags",
      width: "15%",
      key: "tags",
      render: (n, record) =>
        n?.map(tag => <Tag key={tag?.id}>{tag.label}</Tag>),
    },
    {
      title: t("InstitutionsListForms.columnsInstitutionsList.groupedBilling"),
      dataIndex: "groupedBilling",
      width: "15%",
      key: "groupedBilling",
      render: (groupedBilling, record) => {
        return isInstitutionGrouped(record)
          ? t("InstitutionsListForms.columnsInstitutionsList.groupedBillingYes")
          : t("InstitutionsListForms.columnsInstitutionsList.groupedBillingNo");
      },
      sorter: (a, b) => {
        return a.groupedBilling - b.groupedBilling;
      },
    },
  ];
};

// Convert inputsInstitutionsList to a function but keep the original name
export const inputsInstitutionsList = () => {
  const { t } = useTranslation(); // Initialize useTranslation

  return [
    {
      parentLabel: null,
      children: [
        {
          label: t("InstitutionsListForms.inputsInstitutionsList.search"),
          placeholder: t(
            "InstitutionsListForms.inputsInstitutionsList.placeholderSearch",
          ),
          name: "search",
          value: "",
          type: "input",
          capitalize: false,
          col: 8,
        },
        {
          label: t("InstitutionsListForms.inputsInstitutionsList.filterByType"),
          name: "type",
          disabled: true,
          value: undefined,
          allowClear: true,
          type: "select",
          selectContent: typesPrestation,
          selectType: "group",
          col: 8,
        },
      ],
    },
  ];
};
